<template>
	<div class="bracket-round" :class="addonClass">
		<div class="bracket-matchup" v-for="matchup in round.matchups">
			<div class="heading" :class="{ 'is-repeat-heading': isDescriptionRepeat(matchup) }">{{ matchup.description }}</div>

			<div class="teams">
				<div class="team team-1" :class="{ 'is-winner': matchup.is_complete && matchup.winner_team_key == matchup.team1_key }">
					<span class="name">
						<span class="seed">({{ matchup.team1_seed }})</span>&nbsp;<TeamLink
							:teamKey="matchup.team1_key"
							:teamName="matchup.team1_name"
						/>
					</span>
					<span
						class="points"
						:class="{ 'has-text-weight-bold': matchup.is_complete && matchup.winner_team_key == matchup.team1_key }"
					>
						{{ matchup.is_complete && !matchup.is_bye ? matchup.team1_points : "" }}
					</span>
				</div>
				<div class="team team-2" :class="{ 'is-winner': matchup.is_complete && matchup.winner_team_key == matchup.team2_key }">
					<span class="name">
						<span class="seed" v-if="!matchup.is_bye">({{ matchup.team2_seed }})</span>&nbsp;<TeamLink
							:teamKey="matchup.team2_key"
							:teamName="matchup.team2_name"
						/>
					</span>
					<span
						class="points"
						:class="{ 'has-text-weight-bold': matchup.is_complete && matchup.winner_team_key == matchup.team2_key }"
					>
						{{ matchup.is_complete && !matchup.is_bye ? matchup.team2_points : "" }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TeamLink from "./TeamLink"

export default {
	components: {
		TeamLink,
	},
	props: {
		round: {
			type: Object,
			required: true,
		},
		addonClass: {
			type: [Object, String],
			required: false,
			default: () => "",
		},
	},
	methods: {
		isDescriptionRepeat(matchup) {
			const index = this.round.matchups.indexOf(matchup)

			return index > 0 && this.round.matchups[index - 1].description == matchup.description
		},
	},
}
</script>
